import Helper from './helper.js'
import Is from './is.js'
import Toast from './toast.js'

export default class Network
{
	static init()
	{
		$('input[type="submit"], button[type="submit"]').on('click', function()
		{
			this.form.setAttribute('__action', $(this).data('action') || 'submit')

			const message = this.getAttribute('data-confirm')
			if(message !== '') this.form.setAttribute('__confirm', message || (Helper.language() === 'ja' ? '更新しますか？' : 'Update?'))
		})
	}

	static form_post(form, callback = null, redirect = true)
	{
		try
		{
			const process = () =>
			{
				$('.__editor').each((index, element) =>
				{
					$(element).data('editor').updateSourceElement()
				})

				const data = new FormData(form)
				data.set('__action', form.getAttribute('__action') || 'submit')

				Network.post(
					form.action || location.pathname,
					data,
					callback,
					redirect,
				)
			}

			if(!form.getAttribute('__confirm')) process()
			else Helper.confirm(form.getAttribute('__confirm'), process)
		}
		catch(exception)
		{
			console.error(exception.message)
		}

		return false
	}

	static post(url, data, callback, redirect)
	{
		(async () =>
		{
			try
			{
				let response = await $.ajax({
					url   : url,
					method: 'POST',

					data: data,

					contentType: false,
					processData: false,
				})

				if(typeof response !== 'object') response = {message: null, success: false}
				if(typeof response.success !== 'boolean') response.success = false

				if(typeof callback === 'function')
				{
					// noinspection JSUnresolvedVariable
					callback(response.success, response.payload)
				}

				if(!response.success)
				{
					Toast.warning(response.message)
				}
				else
				{
					if(Is.filled(response.message)) Toast.success(response.message)

					if(redirect !== false)
					{
						setTimeout(() =>
						{
							if(redirect === true) location.reload()
							else location.href = redirect
						}, 2000)
					}
				}
			}
			catch(exception)
			{
				let error = exception.message !== undefined ? exception.message : `HTTP ${exception.status} : エラーが発生しました`
				Toast.error(error)
			}
		})()
	}
}
